import {BiEnvelope, BiLogoFacebook, BiLogoInstagram, BiLogoLinkedin, BiMenu, BiX} from "react-icons/bi";
import {BACKGROUND, LOGO} from "./assets/images/Images";
import {NavLink, useHistory, Link} from "react-router-dom";
import $ from "jquery";
import {toast} from "react-toastify";
import {useState} from "react";
import API_LINK from "../components/links/Link";
import {FiEye, FiEyeOff} from "react-icons/fi";

export default function Login() {
    const history = useHistory();
    const [isPassword, setIsPassword] = useState(true);
    const onCheckboxChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
    };

    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $('.LoginForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else {
            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "UserLogin");
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                if (result.data.length > 0) {
                                    if (result.data[0].Status === "Pending") {
                                        toast.update(toaster, {
                                            type: "info",
                                            render: "Un-verified Account.Please make sure you have activated your account.",
                                            isLoading: false,
                                            autoClose: toaster,
                                            closeButton: true,
                                            pauseOnHover: false,
                                            pauseOnFocusLoss: false,
                                            closeOnClick: true,
                                        })
                                        form.find("button").attr("disabled", false);
                                    } else if (result.data[0].Status === "Rejected") {
                                        toast.update(toaster, {
                                            type: "warning",
                                            render: "Your account has been rejected.",
                                            isLoading: false,
                                            autoClose: toaster,
                                            closeButton: true,
                                            pauseOnHover: false,
                                            pauseOnFocusLoss: false,
                                            closeOnClick: true,
                                        })
                                        form.find("button").attr("disabled", false);
                                    } else {
                                        let user = result.data[0];
                                        localStorage.setItem("UserId", user.id)
                                        localStorage.setItem("UserName", user.UserName)
                                        localStorage.setItem("FirstName", user.FirstName)
                                        localStorage.setItem("LastName", user.LastName)
                                        localStorage.setItem("Email", user.Email)
                                        localStorage.setItem("Password", user.Password)
                                        localStorage.setItem("Date", user.Date)
                                        localStorage.setItem("Avatar", user.Avatar)
                                        localStorage.setItem("Type", user.Type)
                                        toast.update(toaster, {
                                            type: "success",
                                            render: "You have successfully logged in. Please wait! redirecting to dashboard.",
                                            isLoading: false,
                                            autoClose: toaster,
                                            closeButton: true,
                                            pauseOnHover: false,
                                            pauseOnFocusLoss: false,
                                            closeOnClick: true,
                                        })
                                        form.find("button").attr("disabled", false);
                                        form.trigger("reset");
                                        setTimeout(() => {
                                            history.push("/user/dashboard");
                                        }, 1500)
                                    }
                                } else {
                                    toast.update(toaster, {
                                        type: "warning",
                                        render: "Wrong credentials. Please make sure to enter accurate information",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                }
                            }, 1000)
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }
    }

    return (
        <>
            <div className="app" style={{backgroundImage: `url(${BACKGROUND})`}}>
            <div className="topbar-container">
                    <ul className={'social-list'}>
                        <li>
                            <a href="mailto:info@1solardirect.com">
                                <BiEnvelope />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/1Solardirect/">
                                <BiLogoFacebook />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/1solardirect/">
                                <BiLogoInstagram />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/1-solar-direct/about/">
                                <BiLogoLinkedin />
                            </a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Contact Us</a>
                        </li>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Get Your Quote</a>
                        </li>
                        <li>
                            <a href="mailto:info@1solardirect.com">Quick Help</a>
                        </li>
                    </ul>
                </div>
                <div className="menu-container">
                <a href="https://1solardirect.com/">
                        <img src={LOGO} alt="Company Logo" className="logo" />
                    </a>
                    <button className="hamburger-menu" onClick={() => {
                        document.getElementById('menu').classList.toggle('show');
                    }}>
                        <BiMenu/>
                    </button>
                    <div className="menu" id={'menu'}>
                        <button className="hamburger-menu hamburger-menu-close" onClick={() => {
                            document.getElementById('menu').classList.toggle('show');
                        }}>
                            <BiX/>
                        </button>
                        <ul>
                            <li>
                                <a href="https://1solardirect.com/">Home</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/about-us/">About Us</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/check-inventory/">Check Inventory</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/our-products/">Our Products</a>
                            </li>
                        </ul>
                        <a href="https://dashboard.1solardirect.com/" className={'menu-btn'}>Login / Register</a>
                    </div>
                </div>
                <div className="app-content">
                    <div className="form">
                        <form className='LoginForm' onSubmit={submitHandle}>
                            <div className="form-header">
                                <h1>Login to <span className={'text-primary'}>1 Solar Direct</span></h1>
                            </div>
                            <div className="form-body">
                                <div className="form-group">
                                    <label htmlFor="">Email Address <code>*</code></label>
                                    <input type="email" id="email" name={'email'} required/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">Password <code>*</code></label>
                                    <div className="password-toggle">
                                        <input type={isPassword ? "password" : "text"} id="password" name={'password'} required/>
                                        <button type="button" className={'btn-password-toggle'}
                                                onClick={() => setIsPassword(!isPassword)}>
                                            {isPassword ? <FiEye/> : <FiEyeOff/>}
                                        </button>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="remember-me">
                                        <input type="checkbox" id="rememberMe"/>
                                        <label htmlFor="rememberMe">Remember Me</label>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <button type={'submit'} className={'btn-primary'}>Login</button>
                                </div>
                                <div className="form-footer">
                                    <Link to={'/auth/register'}>Request an account</Link>
                                    <Link to={'/auth/forgot-password'}>Forgot Password?</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
